<template>
  <div id="jac-region-board-members-list">
    <overlay-loading-progress
      :LoadingFlag="OverlayLoadingFlag"
      :LoadingText="OverlayLoadingText"
    ></overlay-loading-progress>
    <v-card>
      <v-card-title class="text-h5">
        <h2>{{ PageTitle }}</h2>
      </v-card-title>

      <v-card-subtitle class="text-h5">
        <h4>{{ PageDescription }}</h4>
      </v-card-subtitle>

      <v-dialog v-model="addRecordPrompt" persistent scrollable max-width="80%">
        <jac-region-board-members-assign
          :AddRecordPrompt="addRecordPrompt"
          :ZoneCode="ZoneCode"
          :Region="Region"
          @hideAddRecordPrompt="hideAddRecordPrompt"
          v-if="addRecordPrompt"
        ></jac-region-board-members-assign>
      </v-dialog>

      <v-dialog
        v-model="editRecordPrompt"
        persistent
        scrollable
        max-width="80%"
      >
        <jac-region-board-members-edit
          :EditRecordPrompt="editRecordPrompt"
          :ZoneCode="ZoneCode"
          :Region="Region"
          :recordData="selectedData"
          @hideEditRecordPrompt="hideEditRecordPrompt"
          v-if="editRecordPrompt"
        ></jac-region-board-members-edit>
      </v-dialog>

      <v-card-text>
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>

        <v-container class="py-0" v-if="SearchClicked && rows.length === 0">
          <v-row wrap>
            <v-col align="center" cols="12" md="12">
              <h4>No records found.</h4>
            </v-col>
          </v-row>
        </v-container>

        <!-- Buttons Section -->
        <v-row wrap>
          <v-col cols="12" md="12" align="center">
            <v-btn
              elevation="30"
              shaped
              tile
              small
              color="#9370d8"
              class="font-size-h6 white--text my-3 mr-5"
              @click.prevent="refreshPageData"
            >
              Refresh
            </v-btn>
            <v-btn
              v-if="SearchClicked"
              elevation="30"
              shaped
              tile
              small
              color="#66cd00"
              class="font-size-h6 my-3 mr-3 white--text"
              @click.prevent="addRecordPrompt = true"
            >
              Assign Member
            </v-btn>
            <!--<v-btn
              v-if="SearchClicked"
              color="#8a2be2"
              @click.prevent="downloadExcel"
              class="btn btn-primary font-size-h6 py-4 my-3 mr-3 white--text"
            >
              Download
            </v-btn>-->
          </v-col>
        </v-row>

        <!-- Form Section -->
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row wrap>
              <v-col cols="12" sm="6" lg="3" md="3">
                <h6><span class="text-danger">*</span> Zone</h6>
                <v-autocomplete
                  @change="getRegionOptions"
                  :items="ZoneCodeOptions"
                  :rules="ZoneCodeRules"
                  v-model="ZoneCode"
                  dense
                  clearable
                  required
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" lg="3" md="3">
                <h6><span class="text-danger">*</span> Region</h6>
                <v-autocomplete
                  :items="RegionOptions"
                  :rules="RegionRules"
                  v-model="Region"
                  dense
                  clearable
                  required
                  outlined
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row wrap>
              <v-col align="center" cols="12" md="12">
                <v-btn
                  :disabled="!valid"
                  color="success"
                  class="btn btn-primary font-size-h6 py-4 my-3 mr-3 white--text"
                  @click="searchForm"
                >
                  Search
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-container>

        <!-- Member Cards -->
        <v-container class="py-0" v-if="SearchClicked && rows.length > 0">
          <v-row wrap>
            <v-col align="center" cols="12" md="12">
              <h3 class="text-primary">{{ rows.length }} members found.</h3>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col align="center" cols="12" md="12">
              <v-data-iterator
                :items="rows"
                :items-per-page="-1"
                hide-default-footer
              >
                <template v-slot:default="props">
                  <v-row>
                    <v-col
                      v-for="item in props.items"
                      :key="item.MemberId"
                      cols="4"
                    >
                      <v-card raised hover elevation="25">
                        <v-card-text>
                          <v-avatar size="200">
                            <img
                              :src="item.ProfilePic"
                              :alt="item.MemberFullname"
                            />
                          </v-avatar>
                          <h3>{{ item.MemberFullname }}</h3>
                          <h3 class="text-primary">
                            {{ item.DesignationName }}
                          </h3>
                          <h4 style="color: green">{{ item.MembershipId }}</h4>
                          <h4 style="color: brown">{{ item.ZoneName }}</h4>
                          <h5 style="color: red">{{ item.RegionName }}</h5>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            elevation="30"
                            shaped
                            tile
                            small
                            color="#008000"
                            class="font-size-h6 white--text"
                            @click="editData(item)"
                          >
                            <v-icon>mdi-pencil</v-icon> Edit
                          </v-btn>
                          <v-btn
                            elevation="30"
                            shaped
                            tile
                            small
                            color="#ff0000"
                            class="font-size-h6 white--text"
                            @click="deleteAlert(item)"
                          >
                            <v-icon>mdi-delete</v-icon> Delete
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </v-col>
          </v-row>
        </v-container>
        <br /><br />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import JacRegionBoardMembersAssign from "@/view/pages/erp/jac-region-board/JacRegionBoardMembersAssign.vue";
import JacRegionBoardMembersEdit from "@/view/pages/erp/jac-region-board/JacRegionBoardMembersEdit.vue";

export default {
  mixins: [common],
  name: "JacRegionBoardMembersList",
  components: {
    JacRegionBoardMembersAssign,
    JacRegionBoardMembersEdit,
  },
  data() {
    return {
      PageTitle: "JAC Regional Board Members",
      PageDescription: "",

      OverlayLoadingFlag: false,
      OverlayLoadingText: "",
      LoadingFlag: false,

      SearchClicked: false,
      valid: true,

      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeRules: [(v) => !!v || "Zone is required"],

      Region: "",
      RegionOptions: [],
      RegionRules: [(v) => !!v || "Region is required"],

      rows: [],

      PageInfo: {},
      JciYearCode: "",

      addRecordPrompt: false,
      selectedData: {},
      editRecordPrompt: false,
    };
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      var n1 = Object.keys(tr).length;
      if (n1 > 0) {
        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        this.JciYearCode = CurrentJciYearId;
      }
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.resetForm();
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "jac_region_board",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },

    hideAddRecordPrompt(flag) {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      console.log(flag);
      if (flag) {
        this.searchForm();
      }
    },

    hideEditRecordPrompt(flag) {
      console.log("hideEditRecordPrompt called");
      this.editRecordPrompt = false;
      if (flag) {
        this.searchForm();
      }
    },

    editData(item) {
      console.log("editData called for:", item);
      var n1 = Object.keys(item).length;
      if (n1 > 0) {
        this.selectedData = item;
        this.editRecordPrompt = true;
      } else {
        var message = "Kindly select one member to edit";
        this.toast("error", message);
      }
    },

    getZoneOptions() {
      console.log("getZoneOptions called");
      this.tableData1 = [];
      this.ZoneCode = "";

      this.ZoneCodeOptions = [];

      this.ZoneCode = "";
      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/zone/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },

    getRegionOptions() {
      console.log("getRegionOptions called for Zone:", this.ZoneCode);

      this.Region = "";
      var selectbox2_source = "Region";
      var selectbox2_destination = "RegionOptions";
      var selectbox2_url = "api/jac-region/options";
      var selectbox2_conditions_array = {
        UserInterface: 1,
        Zone: this.ZoneCode,
      };
      this.getSelectBoxOptions(
        selectbox2_source,
        selectbox2_destination,
        selectbox2_conditions_array,
        selectbox2_url
      );
    },

    searchForm() {
      if (this.$refs.form.validate()) {
        console.log(
          "searchForm called - Zone:",
          this.ZoneCode,
          "Region:",
          this.Region
        );

        this.SearchClicked = true;
        this.LoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/year-wise-designation/lists";
        var upload = {
          UserInterface: 11,
          OrganizationTypeId: 9,
          YearCode: this.JciYearCode,
          ZoneCode: this.ZoneCode,
          Region: this.Region,
          ExceptDesignationId: [1, 5, 7, 161],
        };

        const thisIns = this;
        this.rows = [];

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            thisIns.LoadingFlag = false;
            var output = response.data.output;
            var flag = response.data.flag;
            var records = response.data.records;

            if (flag == 1) {
              thisIns.rows = records.TableData;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      }
    },

    deleteAlert(item) {
      console.log("deleteAlert called");
      var n1 = Object.keys(item).length;
      if (n1 > 0) {
        this.selectedData = item;
        this.confirmAlert();
      } else {
        var message = "Kindly select one record to delete";
        this.sweetAlert("error", message, false);
      }
    },

    confirmAlert() {
      console.log("confirmAlert called");
      var tr = this.selectedData;
      var n1 = Object.keys(tr).length;
      if (n1 > 0) {
        var htmlTxt = "";
        htmlTxt += "<br/>Member Name <b> " + tr.MemberFullname + "</b>";
        htmlTxt += "<br/>Designation <b> " + tr.DesignationName + "</b>";
        htmlTxt += "<br/>Membership Id <b> " + tr.MembershipId + "</b>";
        htmlTxt += "<br/><br/>Do you want to delete the data?";

        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to delete the data?",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Delete`,
          confirmButtonColor: "#d33",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteRecord(tr);
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "Kindly select one record to delete";
        this.sweetAlert("error", message, false);
      }
    },

    deleteRecord(tr) {
      console.log("deleteRecord called");
      var n1 = Object.keys(tr).length;

      if (n1 > 0) {
        this.OverlayLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/year-wise-designation/member-delete";
        var upload = {
          UserInterface: 9,
          OrganizationType: 9,
          Year: this.JciYearCode,
          Zone: tr.ZoneId,
          Region: tr.RegionId,
          Member: tr.MemberId,
          Designation: tr.DesignationId,
          YearwiseOfficesHeld: tr.YearwiseOfficesHeldId,
        };

        const thisIns = this;
        var output = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            thisIns.OverlayLoadingFlag = false;
            output = response.data.output;
            flag = response.data.flag;

            if (flag == 1) {
              thisIns.toast("success", output);
              thisIns.searchForm(); // Refresh the list
            } else {
              thisIns.sweetAlert("error", output, true);
            }
          })
          .catch(function (error) {
            thisIns.OverlayLoadingFlag = false;
            thisIns.toast("error", error);
          });
      }
    },

    resetForm() {
      this.ZoneCode = "";
      this.Region = "";
      this.rows = [];
      this.SearchClicked = false;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
  mounted() {
    this.getZoneOptions();
  },
};
</script>
